import styled from 'styled-components';

export const ProductMenuModalContainer = styled.div`
  .modal {
    border-radius: 18px;
  }

  .body {
    padding: 36px 42px 40px 42px;
    background: #ffffff;
    border-radius: 18px;
  }

  .title {
    text-align: center;
    font-size: 34px;
    font-weight: 500;
    margin-bottom: 28px;
    color: #111827;
  }

  .card {
    background: #ffffff;
    border-radius: 16px;
    padding: 22px;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.06);
    cursor: pointer;
    transition: 160ms ease;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 12px 34px rgba(0, 0, 0, 0.09);
    }
  }

  .cardTitle {
    color: #2f80ed;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 12px;
  }

  .imgWrap {
    height: 170px;
  }

  .img {
    max-height: 170px;
    object-fit: contain;
  }

  .imgFallback {
    width: 260px;
    height: 170px;
    border-radius: 12px;
    background: #f3f4f6;
  }

  .card--disabled {
    opacity: 0.35;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.03);

    &:hover {
      transform: none;
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.03);
    }

    .cardTitle {
      color: #9ca3af;
    }

    .img {
      filter: grayscale(100%);
    }
  }
`;
